import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

import { SearchForm, SearchFormContext } from '~/components';

import { toUpperCase } from '~/utils';
import { AddressDropdown } from '../address-dropdown';

import styles from './SearchFormContainer.scss';

export class SearchFormContainer extends PureComponent {
  render() {
    const {
      addresses,
      context,
      storeSearchQuery,
      dispatchResetErrorMessagesWith,
      children,
      selectedAddress,
      selectAddressHandler,
      toggleAddressFormState,
      findHandler,
      useCurrentLocationHandler,
      isCurrentLocationLoading,
      validate,
      addressFormLinkLabel,
      buildDefaultOptionLabel,
    } = this.props;

    const [searchFormMessages, addressMessages, screenNav] = React.Children.toArray(children);
    return (
      <Fragment>
        <div className={styles.PostcodeSearchForm}>
          <SearchFormContext.Provider value={context}>
            <SearchForm
              title="Enter property postcode"
              onSubmitHandler={findHandler}
              onSubmitByLocationHandler={useCurrentLocationHandler}
              isLocationLoading={isCurrentLocationLoading}
              storeSearchQuery={storeSearchQuery}
              resetErrorMessagesWith={dispatchResetErrorMessagesWith}
              transformSearchQuery={toUpperCase}
              sensitiveSearchInput
              validate={validate}
            >
              {searchFormMessages}
            </SearchForm>
          </SearchFormContext.Provider>
          {addresses && (
            <AddressDropdown
              addresses={addresses}
              showAddressFormHandler={toggleAddressFormState}
              selectAddress={selectAddressHandler}
              selectedAddress={selectedAddress}
              buildDefaultOptionLabel={buildDefaultOptionLabel}
              addressFormLinkLabel={addressFormLinkLabel}
            >
              {addressMessages}
            </AddressDropdown>
          )}
        </div>
        {screenNav}
      </Fragment>
    );
  }
}

SearchFormContainer.propTypes = {
  storeSearchQuery: PropTypes.string,
  context: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
  addresses: PropTypes.arrayOf(PropTypes.shape({})),
  selectedAddress: PropTypes.string.isRequired,
  selectAddressHandler: PropTypes.func.isRequired,
  toggleAddressFormState: PropTypes.func.isRequired,
  findHandler: PropTypes.func.isRequired,
  useCurrentLocationHandler: PropTypes.func.isRequired,
  isCurrentLocationLoading: PropTypes.bool.isRequired,
  dispatchResetErrorMessagesWith: PropTypes.func.isRequired,
  validate: PropTypes.func,
  addressFormLinkLabel: PropTypes.string,
  buildDefaultOptionLabel: PropTypes.func,
};

SearchFormContainer.defaultProps = {
  storeSearchQuery: '',
  addresses: null,
  validate: undefined,
  addressFormLinkLabel: null,
  buildDefaultOptionLabel: null,
};
